// extracted by mini-css-extract-plugin
module.exports = {"addToCartButtonSection":"az_Lad","addToCartButton":"az_Mad","assortmentTotalText":"az_Nad","itemsTotalPrice":"az_Oad"};